module.exports = __webpack_public_path__ + "img/044-maloik.5af39ff7.svg";